<template>
  <div class="time-table-row">
    <span class="time-table-row__code ms-ellipsis ms-small-head">
      {{ project.code }}
    </span>
    <span class="time-table-row__name ms-text">
      <ellipsis-text :max-width="320" :text="project.name" />
    </span>
    <span class="time-table-row__performer ms-ellipsis ms-help">
      {{ project.performer }}
    </span>
    <span class="time-table-row__costs">
      <tag class="ms-costs" color="primary">
        {{ getFormattedCosts(project.costs, false, project.with_vat) }}
      </tag>
    </span>
    <span class="time-table-row__dates ms-help">
      <tag>{{ formatDefaultDate(project.start_date) }}</tag>
    </span>
    <div class="time-table-row__manager ms-help" v-if="$mq !== 'md'">
      {{ project.manager_name }}
    </div>
    <div class="time-table-row__statuses">
      <tooltip
        :transfer="false"
        max-width="200"
        placement="top"
        :delay="1000"
      >
        <tag color="geekblue">
          <badge :status="project.ukii_dates_signed ? 'success' : 'error'" />
          /
          <badge :status="project.ukii_expired ? 'error' : 'success'" />
        </tag>
        <div class="time-table-row__tooltip" slot="content">
          <p>Блок выпуска ТО</p>
          <div>
            <badge
              :status="project.ukii_dates_signed ? 'success' : 'error'"
              :text="project.ukii_dates_signed ? 'Даты указаны' : 'Даты не указаны'"
            />
          </div>
          <div>
            <badge
              :status="project.ukii_expired ? 'error' : 'success'"
              :text="project.ukii_expired ? 'Отклонение сроков' : 'Без отклонения'"
            />
          </div>
        </div>
      </tooltip>
      <tooltip
        :transfer="false"
        max-width="200"
        placement="top"
        :delay="1000"
      >
        <tag color="purple">
          <badge :status="project.acts_dates_signed ? 'success' : 'error'" />
          /
          <badge :status="project.acts_expired ? 'error' : 'success'" />
        </tag>
        <div class="time-table-row__tooltip" slot="content">
          <p>Блок подписания актов</p>
          <div>
            <badge
              :status="project.acts_dates_signed ? 'success' : 'error'"
              :text="project.acts_dates_signed ? 'Даты указаны' : 'Даты не указаны'"
            />
          </div>
          <div>
            <badge
              :status="project.acts_expired ? 'error' : 'success'"
              :text="project.acts_expired ? 'Отклонение сроков' : 'Без отклонения'"
            />
          </div>
        </div>
      </tooltip>
      <tooltip
        :transfer="false"
        max-width="200"
        placement="left"
        content="Блок получения платежей (даты указаны / отклонение сроков)"
        :delay="1000"
      >
        <tag color="green">
          <badge :status="project.payments_dates_signed ? 'success' : 'error'" />
          /
          <badge :status="project.payments_expired ? 'error' : 'success'" />
        </tag>
        <div class="time-table-row__tooltip" slot="content">
          <p>Блок получения платежей</p>
          <div>
            <badge
              :status="project.payments_dates_signed ? 'success' : 'error'"
              :text="project.payments_dates_signed ? 'Даты указаны' : 'Даты не указаны'"
            />
          </div>
          <div>
            <badge
              :status="project.payments_expired ? 'error' : 'success'"
              :text="project.payments_expired ? 'Отклонение сроков' : 'Без отклонения'"
            />
          </div>
        </div>
      </tooltip>
    </div>
    <div class="time-table-row__amendments" v-if="project.amendments.length">
      <i-select
        v-model="amendment"
        @on-change="changeAmendment"
        not-found-text="ДС отсутствуют"
        @click.native="amendmentClickHandler"
        :disabled="!isCurrentOpened"
      >
        <i-option
          v-for="item in getAmendments()"
          :value="item.id"
          :key="item.id"
        >
          {{ item.id === 'original' ? 'Основной договор' : `ДС №${item.number}` }}
        </i-option>
      </i-select>
    </div>
    <div class="time-table-row__select" v-if="selectedMode">
      <checkbox
        @click.native="selectClickHandler($event)"
        @on-change="toggleProject"
        v-model="isSelected"
      />
    </div>
  </div>
</template>

<script>
import { getFormattedCosts, formatDefaultDate } from '@/utils'
import EllipsisText from '@/components/parts/ellipsis-text'

export default {
  props: ['project', 'index', 'opened'],
  components: {
    EllipsisText
  },
  data () {
    return {
      amendment: '',
      isSelected: this.$store.state.selectedToExport.indexOf(this.project.id) > -1
    }
  },
  watch: {
    selected: {
      handler: function (val) {
        if (!val.length) this.isSelected = false
        else if (val.indexOf(this.project.id) > -1) this.isSelected = true
      },
      deep: true
    }
  },
  computed: {
    isCurrentOpened () {
      return this.opened.indexOf(String(this.index)) > -1
    },
    selected () {
      return this.$store.state.selectedToExport || []
    },
    selectedMode () {
      return this.$store.state.selectedMode
    }
  },
  methods: {
    toggleProject () {
      this.$store.commit('TOGGLE_SELECTED_CONTRACT', this.project.id)
    },
    selectClickHandler (e) {
      e.stopPropagation()
    },
    getAmendments () {
      return [
        { id: 'original' },
        ...this.project.amendments
      ]
    },
    changeAmendment (amendment_id) {
      this.$emit('change-amendment', { index: this.index, amendment_id })
    },
    amendmentClickHandler (e) {
      e.stopPropagation()
    },
    getFormattedCosts,
    formatDefaultDate
  },
  created () {
    if (this.project.amendments.length) {
      this.amendment = this.project.amendments[this.project.amendments.length - 1].id
    }
  }
}
</script>

<style lang="less">
.time-table-row {
  display: flex;
  align-items: center;
  flex: 1;
  padding-right: 16px;

  &__code {
    margin-right: 4px;
    display: inline-block;
    width: 100px;
  }

  &__name {
    display: inline-block;
    width: 320px;
  }

  &__performer {
    display: inline-block;
    width: 96px;
    margin-left: 16px;
  }

  &__costs {
    margin-left: 16px;

    .ivu-tag {
      width: 182px;
      text-align: center;
    }
  }

  &__dates {
    margin-left: 16px;
    margin-right: 16px;

    .ivu-tag {
      background: #fff;
    }
  }

  &__manager {
    margin-left: 16px;
  }

  &__statuses {
    margin-left: auto;

    .ivu-tag-text {
      .ivu-badge-status-text {
        display: none;
      }

      .ivu-badge-status-error {
        background-color: rgba(250, 83, 28, 0.8);
      }

      .ivu-badge-status-success {
        background-color: rgba(25, 190, 108, 0.8);
      }
    }
  }

  &__amendments {
    margin-left: 16px;
  }

  .ivu-tooltip-inner {
    text-align: center;

    .ivu-badge-status-text {
      color: #fff;
    }
  }

  &__tooltip {
    font-size: 12px;

    .ivu-badge-status-text {
      font-size: 12px;
    }
  }

  &__select {
    margin-left: 16px;

    .ivu-checkbox-wrapper {
      margin: 0;
    }
  }
}
</style>
